module.exports = __webpack_public_path__ + "img/lyzw.9223c0ff.jpg";